import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/vengean.webp';
import screenshot_target from '../../../images/letterfunnel/andymosmans.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Andy Mosmans"
      firstname="Andy"
      companyname="VENGEAN"
      competition="KesselsKramer en Springbok"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/andymosmans.js